import React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import FTLTypography from "./FTLTypography";
import CloseIcon from "../icons/Close";
const styleMixin = (status, theme) => {
    switch (status) {
        case "new":
            return {
                backgroundColor: theme.palette.status.newBg,
                color: theme.palette.status.newText,
            };
        case "success":
            return {
                backgroundColor: theme.palette.status.successBg,
                color: theme.palette.status.successText,
            };
        case "error":
            return {
                backgroundColor: theme.palette.status.errorBg,
                color: theme.palette.status.errorText,
            };
        case "disabled":
            return {
                backgroundColor: theme.palette.status.disabledBg,
                color: theme.palette.status.disabledText,
            };
        case "info":
            return {
                backgroundColor: theme.palette.status.infoBg,
                color: theme.palette.status.infoText,
            };
        case "warning":
            return {
                backgroundColor: theme.palette.status.warningBg,
                color: theme.palette.status.warningText,
            };
        default:
            return {
                backgroundColor: theme.palette.status.neutralBg,
                color: theme.palette.status.neutralText,
            };
    }
};
const sizeStyleMixin = (size) => {
    switch (size) {
        case "small":
            return { padding: "2px 4px" };
        case "medium":
            return { padding: "6px 4px" };
        case "large":
            return { padding: "16px 18px" };
        default:
            return {};
    }
};
export default ({ status = "neutral", size = "small", isCloseable, onClose, icon, children, style, TypographyProps, closeIcon, }) => {
    const classes = useStyles({ status, size, icon });
    return (React.createElement("div", { className: classes.container, style: style },
        icon,
        React.createElement(FTLTypography, Object.assign({ variant: "listItemNavText", color: "inherit", className: classes.typographyBox, component: "div" }, TypographyProps), children),
        (isCloseable || closeIcon) && (React.createElement("div", { onClick: onClose, className: classes.closeContainer }, closeIcon ? closeIcon : React.createElement(CloseIcon, null)))));
};
const useStyles = makeStyles((theme) => createStyles({
    container: ({ size, status, }) => (Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.listItemText), { borderRadius: 4, fontWeight: 400, display: size === "large" ? "flex" : "inline-flex", alignItems: "center", justifyContent: "flex-start", wordBreak: "keep-all" }), styleMixin(status, theme)), sizeStyleMixin(size))),
    typographyBox: ({ size, icon, }) => ({
        padding: size === "large" && icon ? "0 0 0 16px" : "0 4px",
    }),
    closeContainer: {
        cursor: "pointer",
        display: "inline-flex",
        alignSelf: "stretch",
        alignItems: "center",
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        "&:hover": {
            background: "#feb5a4",
        },
    },
}));
//# sourceMappingURL=FTLStatusTag.js.map